import script from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutView.vue?vue&type=style&index=0&id=255608da&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255608da"]])

export default __exports__